import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, RouterOutlet, RouterLink, RouterLinkActive } from '@angular/router';
import { AvailableLangs, TranslocoService, TranslocoPipe } from '@jsverse/transloco';
import { KeycloakService } from 'keycloak-angular';
import { ConfigService } from './services/config/config.service';
import { SlugManagerService } from './services/slug/slug-manager.service';
import { UserStorage } from './services/storage/local-storage.model';
import { ThemeService } from './services/theme/theme.service';
import { UserDataService } from './services/userdata/userdata.service';
import { LoaderComponent } from './pages/common/loader/loader.component';
import { ErrorPageComponent } from './pages/common/error-page/error-page.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [CommonModule, FormsModule, RouterOutlet, RouterLink, RouterLinkActive, TranslocoPipe, LoaderComponent, ErrorPageComponent]
})
export class AppComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly config = inject(ConfigService);
  private readonly themeService = inject(ThemeService);
  private readonly keycloakService = inject(KeycloakService);
  private readonly userDataService = inject(UserDataService);
  private readonly translocoService = inject(TranslocoService);
  private readonly slugManagerService = inject(SlugManagerService);

  title = 'sircles-web';
  userData: UserStorage;
  availableLangs: AvailableLangs;
  userLoad = false;
  isSmall = false;
  currentLanguage: string;
  currentTheme: string;

  ngOnInit() {
    this.getUserInterval();
    this.updateUserDataAfterTime(30);
  }

  logout() {
    localStorage.removeItem('user');
    this.keycloakService.logout();
  }

  selectLanguage(language: string) {
    this.translocoService.setActiveLang(language);
    this.currentLanguage = language;
    this.userData.lang = language;
  }

  search(search: string) {
    if (search.length >= 3) {
      this.router.navigate(['search', search]);
    }
  }

  searchSubmit(search: string) {
    if (search.length >= 2) {
      this.router.navigate(['search', search]);
    }
  }

  stopPropagation(e) {
    e.stopPropagation();
  }

  toggleTheme() {
    const theme = this.currentTheme === 'light-theme' ? 'dark-theme' : 'light-theme';
    this.themeService.setTheme(theme);
    this.currentTheme = theme;
  }

  getTheme() {
    return this.currentTheme === 'dark-theme' ? '_white' : '';
  }

  getDefaultAvatar(userName: string) {
    return `${this.config.savatarUrl}${userName}`;
  }
  updateUserDataAfterTime(time: number) {
    setInterval(() => this.userDataService.refreshUserData(), time * 1000);
  }
  getUserInterval() {
    const getUserInterval = setInterval(() => {
      this.themeService.checkThemeOnStart();
      this.currentTheme = this.themeService.currentTheme();
      this.userDataService.setUserData();
      this.userDataService.getUserData().subscribe((data) => {
        this.userData = data;
      });
      if (this.userData) {
        this.slugManagerService.loadSlugger();
      }

      this.isSmall = window.innerWidth < 991;
      if (this.userData?.menu) {
        this.availableLangs = this.translocoService.getAvailableLangs();
        this.currentLanguage = this.userData?.lang
          ? this.userData.lang
          : this.translocoService.getDefaultLang();
        this.translocoService.setActiveLang(this.currentLanguage);
        this.userLoad = true;
        clearInterval(getUserInterval);
      }
    }, 100);
  }
}
